import { useApp } from '@/context/AppContext';

export default function MobileJobs() {
  const { jobs = [], custById } = useApp();
  return (
    <div style={{ padding: 16 }}>
      <h2 style={{ marginTop: 0 }}>Jobs</h2>
      {jobs.length === 0 ? (
        <div className="card" style={{ padding: 24, textAlign: 'center', color: 'var(--t3, #6b7280)' }}>
          <div style={{ fontSize: 40 }}>🏗️</div>
          <p>No jobs yet. Use the desktop view to create a job.</p>
        </div>
      ) : (
        <div style={{ display: 'grid', gap: 10 }}>
          {jobs.map(j => {
            const cust = custById(j.customerId);
            return (
              <div key={j.id} className="card" style={{ padding: 14 }}>
                <div style={{ fontWeight: 700 }}>{j.jobNumber || `Job #${j.id}`}</div>
                <div style={{ color: 'var(--t2)', fontSize: 13 }}>{j.projectName || '—'}</div>
                <div style={{ color: 'var(--t3, #6b7280)', fontSize: 12, marginTop: 4 }}>
                  {cust?.name || ''}{j.status ? ` · ${j.status}` : ''}{j.dueDate ? ` · due ${j.dueDate}` : ''}
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
